import { BusinessProfileConstants, jobsConstants } from '../_constants';
import { CrmService } from '../_services';
import { toast } from 'react-toastify';

export const BusinessProfileActions = {
  BusinessJobVacancy,
  GetApplicants,
  GetCompanies,

  BusinessGetUsers,
  BusinessGetNews,
  BusinessDeleteNewById,

  CreateNews,
  CreateUser,

  SetTabApplicants,

  downloadReport,
  DownloadApplicantsExport,

  SetTabVacancies,
  SetVacanyDays,
  SetApplicantsDays,
};

function SetVacanyDays(value) {
  return (dispatch, getState) => {
    const { tabVacancies } = getState().businessProfileReducers;
    const params = { ...tabVacancies };
    params.lasdays = value;

    dispatch({
      type: BusinessProfileConstants.SET_TAB_VACANCIES,
      payload: params,
    });
  };
}

function SetApplicantsDays(value) {
  return (dispatch, getState) => {
    const { tabApplicants } = getState().businessProfileReducers;
    const params = { ...tabApplicants };
    params.lasdays = value;

    dispatch({
      type: BusinessProfileConstants.SET_TAB_APPLICANTS,
      payload: params,
    });
  };
}

function SetTabVacancies(value) {
  return (dispatch, getState) => {
    const options = {
      1: null,
      2: true,
      3: false,
    };

    const { tabVacancies } = getState().businessProfileReducers;
    const params = { ...tabVacancies };
    params.is_active = options[value];

    dispatch({
      type: BusinessProfileConstants.SET_TAB_VACANCIES,
      payload: params,
    });
  };
}

function downloadReport() {
  return async (dispatch) => {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING_REPORT,
      payload: true,
    });
    try {
      const response = await CrmService.JobpostsExport();
      downloadBlob(response.data, `vacantes-${Date.now()}.xls`);
    } catch (error) {
      dispatchError(dispatch, error);
    } finally {
      dispatch({
        type: BusinessProfileConstants.IS_LOADING_REPORT,
        payload: false,
      });
    }
  };
}

function DownloadApplicantsExport() {
  return async (dispatch) => {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING_REPORT,
      payload: true,
    });
    try {
      const response = await CrmService.ApplicantsExport();
      downloadBlob(response.data, `solicitantes-${Date.now()}.xls`);
    } catch (error) {
      dispatchError(dispatch, error);
    } finally {
      dispatch({
        type: BusinessProfileConstants.IS_LOADING_REPORT,
        payload: false,
      });
    }
  };
}

function downloadBlob(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function dispatchError(dispatch, error) {
  dispatch({
    type: BusinessProfileConstants.UPDATE_ERROR,
    payload: error,
  });
}

function SetTabApplicants(value) {
  return function (dispatch, getState) {
    const options = {
      1: '',
      2: 'Hired',
      3: 'Interview',
      4: 'Pending',
      5: 'Rejected',
    };

    const { tabApplicants } = getState().businessProfileReducers;
    const params = { ...tabApplicants };
    params.status = options[value];

    dispatch({
      type: BusinessProfileConstants.SET_TAB_APPLICANTS,
      payload: params,
    });
  };
}

function GetApplicants(url) {
  return async function (dispatch, getState) {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: true,
    });
    const { tabApplicants } = getState().businessProfileReducers;

    const response = await CrmService.GetApplicants(url, tabApplicants);
    dispatch({
      type: BusinessProfileConstants.UPDATE_DATA_REQUEST,
      payload: response.data,
    });

    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: false,
    });
  };
}

function BusinessJobVacancy(url) {
  return async function (dispatch, getState) {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: true,
    });

    const { tabVacancies } = getState().businessProfileReducers;
    const response = await CrmService.BusinessJobVacancy(url, tabVacancies);
    dispatch({
      type: BusinessProfileConstants.UPDATE_DATA_REQUEST,
      payload: response.data,
    });

    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: false,
    });
  };
}

function GetCompanies(_text) {
  return async function (dispatch) {
    dispatch({
      type: jobsConstants.UPDATE_LOADING,
      payload: true,
    });

    const response = await CrmService.GetCompanies();
    dispatch({
      type: jobsConstants.UPDATE_COMPANIES,
      payload: response.data.results,
    });
    dispatch({
      type: jobsConstants.UPDATE_LOADING,
      payload: false,
    });
  };
}

function BusinessGetNews() {
  return async function (dispatch) {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: true,
    });

    const response = await CrmService.GetNews();
    dispatch({
      type: BusinessProfileConstants.UPDATE_NEWS,
      payload: response.data,
    });
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: false,
    });
  };
}

function BusinessDeleteNewById(id) {
  return async function (dispatch) {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: true,
    });

    try {
      await CrmService.delteNewById(id);
      const response2 = await CrmService.GetNews();
      dispatch({
        type: BusinessProfileConstants.UPDATE_NEWS,
        payload: response2.data,
      });
    } catch (_error) {
      toast.error('No fue posible eliminar la noticia', {
        type: 'error',
      });
    }
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: false,
    });
  };
}

function BusinessGetUsers(_text) {
  return async function (dispatch) {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: true,
    });

    const response = await CrmService.GetUsers();
    dispatch({
      type: BusinessProfileConstants.UPDATE_USERS,
      payload: response.data,
    });
    dispatch({
      type: BusinessProfileConstants.IS_LOADING,
      payload: false,
    });
  };
}

function CreateNews(data, reset) {
  return async function (dispatch) {
    try {
      dispatch({
        type: BusinessProfileConstants.IS_LOADING_MODAL,
        payload: true,
      });

      const formData = new FormData();
      formData.append('title', data.title);
      formData.append('subtitle', data.subtitle);
      formData.append('image', data.image[0]);

      await CrmService.CreateNews(formData);
      reset();
      toast.success('Noticia creada correctamente', {
        type: 'success',
      });

      dispatch({
        type: BusinessProfileConstants.IS_OK,
        payload: true,
      });
    } catch (_error) {
      toast.error('ha ocurrido un error, intenta más tarde', {
        type: 'error',
      });
    }
    dispatch({
      type: BusinessProfileConstants.IS_LOADING_MODAL,
      payload: false,
    });
  };
}

function CreateUser(data, reset, toast) {
  return async function (dispatch) {
    dispatch({
      type: BusinessProfileConstants.IS_LOADING_MODAL,
      payload: true,
    });
    try {
      await CrmService.CreateUsers(data);
      toast.success('Usuario creado correctamente', {
        type: 'success',
      });
      reset();
    } catch (err) {
      toast.error(err.response.data.email[0], {
        type: 'error',
      });
    }

    dispatch({
      type: BusinessProfileConstants.IS_LOADING_MODAL,
      payload: false,
    });
  };
}
